import styled from 'styled-components/macro';
import { UserContainer } from '../../Common/styles';

export const CanvasBuilderContainer = styled(UserContainer)`
  background: #f5f5f5;
  min-height: 100vh;
  overflow: auto;
  display: flex;
  justify-content: center;

  & .header-section {
    background: white;
    padding: 12px 24px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-bottom: 16px;
  }

  & .canvas-container {
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;
  }

  & .toolbar {
    width: 200px;
    height: calc(100vh - 160px);
    min-height: 500px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    overflow-y: auto;
    border: 1px solid #e8e8e8;
    backdrop-filter: blur(8px);
    position: absolute;
    left: 16px;
    top: 16px;
    z-index: 10;
  }

  & .toolbar-section {
    margin-bottom: 20px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }

  & .toolbar-title {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
    margin-bottom: 12px;
    padding-bottom: 6px;
    border-bottom: 1px solid #f0f0f0;
  }

  & .canvas-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #e8ecef;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  & .canvas-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  & .canvas {
    width: 1920px;
    height: 1080px;
    flex-shrink: 0; /* Critical: prevent flexbox from shrinking the logical grid */
    cursor: crosshair;
    background: linear-gradient(90deg, #f8f8f8 1px, transparent 1px),
                linear-gradient(#f8f8f8 1px, transparent 1px);
    background-size: 20px 20px;
    position: relative;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
  }

  & .properties-panel {
    width: 340px;
    height: calc(100vh - 160px);
    min-height: 500px;
    background: rgba(245, 245, 245, 0.95);
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    overflow-y: auto;
    border: 1px solid #e8e8e8;
    backdrop-filter: blur(8px);
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 10;
    
    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
      width: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f0f0f0;
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 4px;
      
      &:hover {
        background: #8c8c8c;
      }
    }
  }

  & .tool-button {
    width: 100%;
    margin-bottom: 6px;
    text-align: left;
    height: 32px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .tool-icon {
      font-size: 16px;
      width: 16px;
      text-align: center;
    }
  }

  & .action-button {
    width: 100%;
    margin-bottom: 6px;
    height: 28px;
    border-radius: 6px;
    font-size: 12px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
  }

  & .property-group {
    margin-bottom: 16px;
    padding: 12px;
    background: #fafafa;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
  }

  & .property-label {
    font-weight: 600;
    margin-bottom: 8px;
    display: block;
    color: #262626;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  & .canvas-object {
    position: absolute;
    cursor: move;
    user-select: none;
  }
  
  & .canvas-object.dragging {
    transition: none;
  }

  & .canvas-object.selected {
    outline: 2px solid #1890ff;
    outline-offset: 2px;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
  }

  & .canvas-object.multi-selected {
    outline: 2px solid #52c41a;
    outline-offset: 2px;
    box-shadow: 0 4px 12px rgba(82, 196, 26, 0.2);
  }

  & .selection-box {
    position: absolute;
    border: 2px dashed #1890ff;
    background: rgba(24, 144, 255, 0.08);
    pointer-events: none;
    border-radius: 4px;
  }

  & .resize-handle {
    position: absolute;
    width: 10px;
    height: 10px;
    background: #1890ff;
    border: 2px solid white;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.2);
      background: #40a9ff;
    }
  }

  & .resize-handle.nw { top: -5px; left: -5px; cursor: nw-resize; }
  & .resize-handle.ne { top: -5px; right: -5px; cursor: ne-resize; }
  & .resize-handle.sw { bottom: -5px; left: -5px; cursor: sw-resize; }
  & .resize-handle.se { bottom: -5px; right: -5px; cursor: se-resize; }

  & .color-input-wrapper {
    display: flex;
    gap: 6px;
    align-items: center;
  }

  & .color-preview {
    width: 32px;
    height: 24px;
    border: 2px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #1890ff;
      transform: scale(1.05);
    }

    input[type="color"] {
      position: absolute;
      width: 100%;
      height: 100%;
      border: none;
      cursor: pointer;
      opacity: 0;
    }
  }

  & .template-name-input {
    border-radius: 6px;
    height: 36px;
  }

  & .header-buttons {
    display: flex;
    gap: 12px;
    align-items: center;

    .ant-btn {
      height: 36px;
      border-radius: 6px;
      font-weight: 500;
      transition: all 0.2s ease;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }

  & .stats-info {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
    padding: 8px;
    background: #f0f9ff;
    border-radius: 6px;
    border: 1px solid #bae7ff;
  }

  & .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;

    .stat-number {
      font-size: 16px;
      font-weight: 600;
      color: #1890ff;
    }

    .stat-label {
      font-size: 10px;
      color: #666;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  & .canvas-info {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 10px;
    pointer-events: none;
    z-index: 10;
  }

  & .preview-canvas {
    position: relative;
    width: 1920px;
    height: 1080px;
    background: white;
    overflow: hidden;
    margin: 0 auto;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    transform-origin: top left;
  }
  
  & .preview-canvas-inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  & .preview-grid {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, #f8f8f8 1px, transparent 1px),
                linear-gradient(#f8f8f8 1px, transparent 1px);
    background-size: 20px 20px;
    opacity: 0.5;
    pointer-events: none;
    z-index: 0;
  }

  & .preview-empty-state {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #999;

    .empty-icon {
      font-size: 48px;
      margin-bottom: 16px;
    }

    .empty-title {
      font-size: 16px;
      margin-bottom: 8px;
      color: #666;
    }

    .empty-description {
      font-size: 14px;
      color: #999;
    }
  }
`;